import { noop } from 'lodash';

import {
   MedicalInformation,
   MedicalInformationAttachment,
   MedicalInformationQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import {
   MarginPosition,
   Notification,
   NotificationSize,
   NotificationType,
   StandardSpinner,
} from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { visitHistoryTranslationKeys } from '../translations';

type VisitHistoryMedicalImagingAttachmentLoaderRenderProps = {
   medicalInformationAttachments: MedicalInformationAttachment[] | undefined;
};

type VisitHistoryMedicalImagingAttachmentProps = {
   readonly visitMedicalInformationId: number;
   readonly children: (renderProps: VisitHistoryMedicalImagingAttachmentLoaderRenderProps) => JSX.Element;
};

export const VisitHistoryMedicalImagingAttachmentLoader = (
   props: VisitHistoryMedicalImagingAttachmentProps
): JSX.Element => {
   const {
      data: medicalInformation,
      loading: medicalInformationLoading,
      error: medicalInformationError,
   } = useCqrsGet<MedicalInformation>(
      () => {
         const query = new MedicalInformationQuery();
         query.id = Slot.of(props.visitMedicalInformationId);
         return query;
      },
      { cacheTime: 'short', onUnexpectedError: noop }
   );

   if (medicalInformationLoading) {
      return <StandardSpinner />;
   }

   if (medicalInformationError) {
      return (
         <Notification
            testId={'noMedicalInformationDataNotification'}
            type={NotificationType.WARNING}
            size={NotificationSize.SMALLER}
            label={visitHistoryTranslationKeys.medicalImagingFetchError}
            margin={MarginPosition.TOP}
         />
      );
   }

   return props.children({
      medicalInformationAttachments: medicalInformation.attachments,
   });
};
